module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/change_tablet-baf776697c53ce4cb6bbc16a9880b7b7.png";